import type {
  ArticleType,
  PatternSymbolColor,
} from "../../../__generated__/gql/graphql";
import { TemplateNodeType } from "../../../__generated__/gql/graphql";
import Button from "../../../ui/Button/Button";
import { Edit } from "../../../ui/Icon/Icon";
import styles from "./PatternPreview.module.scss";
import PatternName from "./PatternName";
import { useFormState } from "react-hook-form";
import articleTypeOptions from "../steps/CreatePattern/forms/article-type-options";

function PatternPreview({
  type,
  templateNodes,
  symbols,
  onEditPattern,
  showSubmit,
}: {
  type?: ArticleType;
  templateNodes: { type: TemplateNodeType; value: string }[];
  symbols: {
    name: string;
    color: PatternSymbolColor;
    values?: string[] | null;
  }[];
  onEditPattern?: () => void;
  showSubmit?: boolean;
}) {
  const { isSubmitting } = useFormState();
  return (
    <div className={styles.patternPreview}>
      <div className={styles.patternContainer}>
        <PatternName
          templateNodes={templateNodes}
          symbols={symbols}
          className={styles.pattern}
        />
        {onEditPattern ? (
          <Button
            leftIcon={<Edit size="small" />}
            onClick={onEditPattern}
            size="xsmall"
            variant="outline"
          >
            Edit Pattern
          </Button>
        ) : null}
        {showSubmit && (
          <Button
            className={styles.submitButton}
            loading={isSubmitting}
            disabled={isSubmitting}
            variant="primary"
            type="submit"
            size="small"
          >
            Continue
          </Button>
        )}
      </div>
      {type ? (
        <div className={styles.patternArticleType}>
          {articleTypeOptions[type]}
        </div>
      ) : null}
    </div>
  );
}

export default PatternPreview;
